module.exports = __webpack_public_path__ + "img/Dra-Adriana-Gallegos-Aguilera.6646d024.jpg";